import {Typography, Grid, MdRenderer} from '@hconnect/uikit'
import {Box} from '@material-ui/core'
import React from 'react'
import {useTranslation} from 'react-i18next'

import confirmationImage from '../../../Assets/confirmationPage/confirmation.svg'
import confirmationErrorImage from '../../../Assets/confirmationPage/confirmationError.svg'
import {ShippingType} from '../../declarations/OrderIntake.enums'

interface ConfirmationSummaryBoxProps {
  allFailed: boolean
  someFailed: boolean
  successCount: number
  failedCount: number
  totalCount: number
  shippingType: ShippingType
  orderIntakeCollectSendingQR: boolean
  isSlotManagementEnabled: boolean
  boxClassName: string
}

export const ConfirmationSummaryBox: React.FC<ConfirmationSummaryBoxProps> = ({
  allFailed,
  someFailed,
  successCount,
  failedCount,
  totalCount,
  shippingType,
  orderIntakeCollectSendingQR,
  isSlotManagementEnabled,
  boxClassName
}) => {
  const {t} = useTranslation()

  return (
    <Grid
      container
      className={boxClassName}
      data-test-id={
        allFailed
          ? 'split-load-order-processing-error'
          : someFailed
            ? 'split-load-order-processing-mixed'
            : 'split-load-order-processing-success'
      }
    >
      <Grid item xs={12} md={10}>
        <Box>
          <Typography variant="h3" color="textPrimary">
            {allFailed
              ? t('orderIntake.confirmationScreen.receiveRequestFailed')
              : someFailed
                ? t('orderIntake.confirmationScreen.partialSuccess')
                : t('orderIntake.confirmationScreen.receiveRequestSuccessfully')}
          </Typography>
          <Typography variant="body2" color="textPrimary">
            {allFailed
              ? t('orderIntake.confirmationScreen.receiveRequestFailedText')
              : someFailed
                ? t('orderIntake.confirmationScreen.partialSuccessText', {
                    successful: successCount,
                    failed: failedCount,
                    total: totalCount
                  })
                : t('orderIntake.confirmationScreen.receiveRequestSuccessfullyText')}
          </Typography>
          {shippingType === ShippingType.COLLECT &&
            orderIntakeCollectSendingQR &&
            successCount > 0 && (
              <Typography variant="body2" color="textPrimary">
                {t('orderIntake.confirmationScreen.receiveRequestSuccessfullyTextCollect')}
              </Typography>
            )}
          {isSlotManagementEnabled ? (
            <MdRenderer
              body={t('orderIntake.confirmationScreen.confirmationLink')}
              paragraphVariant="body2"
            />
          ) : null}
        </Box>
      </Grid>
      <Grid item xs={12} md={2}>
        <img
          src={allFailed ? confirmationErrorImage : confirmationImage}
          data-test-id="split-load-confirmation-image"
          style={{float: 'right', maxWidth: 100}}
          alt={t('orderIntake.confirmationScreen.receiveRequestSuccessfully')}
        />
      </Grid>
    </Grid>
  )
}
